import { Component, Inject } from '@angular/core';
import { SCREEN_LAYOUT, ScreenLayout } from '../core/layout/layout.provider';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerViewModel } from './customer.service';
import { DataService } from '../data/data.service';
import { Country } from '../data/countries';

@Component({
    selector: 'app-new-customer',
    styles: [`
    :host {
      display: block;
      height: 100%;
      width: 100%;
    }
  `],
    template: `
    <div class="modal-header">
      <h4 class="modal-title" id="exampleModalLabel" i18n>Kunden erstellen</h4>
      <button type="button" class="btn-close" aria-label="Close" i18n-aria-label (click)="modalService.close()"></button>
    </div>
    <div class="modal-body d-flex p-0">
      <app-new-customer-form [countries]="countries" (formSubmitted)="customerCreated($event)"></app-new-customer-form>
    </div>
  `,
    standalone: false
})
export class NewCustomerPage {
  countries: Country[] = [];

  constructor(@Inject(SCREEN_LAYOUT) public layout: ScreenLayout,
              public readonly modalService: NgbActiveModal,
              private readonly dataService: DataService
  ) {
    this.fetchCountries();
  }

  customerCreated(customer: CustomerViewModel) {
    this.modalService.close(customer);
  }

  async fetchCountries() {
    this.countries = await this.dataService.fetchCountries();
  }
}
